import { render } from "./nimp_foreground_image.vue?vue&type=template&id=6f155a6c&scoped=true"
import script from "./nimp_foreground_image.vue?vue&type=script&lang=js"
export * from "./nimp_foreground_image.vue?vue&type=script&lang=js"

import "./nimp_foreground_image.vue?vue&type=style&index=0&id=6f155a6c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f155a6c"]])

export default __exports__